import type { FunctionComponent } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { createClassName, createStyleHelper } from '../../shared/utils/class-names';
import { DocumentsDropdown } from '../containers/dropdown/dropdown';

import styles from './documents.module.scss';

const style = createStyleHelper(styles, 'documents-layout');

export interface IDocumentsProps {
    className?: string;
}

export const DocumentsLayout: FunctionComponent<IDocumentsProps> = ({ className }) => {
    const { slug } = useParams();

    if (!slug) {
        throw new Error('No slug provided to the documents layout. Unrecoverable error.');
    }

    return (
        <div className={createClassName([className, style()])}>
            <div className={style('dropdown')}>
                <DocumentsDropdown slug={slug} />
            </div>

            <div className={style('content')}>
                <Outlet />
            </div>
        </div>
    );
};
